<template>
  <div class="content">
    <div class="alertWrap" >
      <el-alert v-show="loginTips"
        :title='loginTipsTitle'
        type="error"
        effect="dark">
      </el-alert>
    </div>

    <div class="loginTop">
      <img src="@/assets/images/common/logo.png" alt="">
      <p>JJLin運營平台</p>
    </div>

    <div class="loginWrap">
      <div class="loginContent hidden-sm-and-down">
        <div class="loginbox">
          <div class="loginboxLeft">
            <img src="@/assets/images/login/contentBg.png" alt="">
          </div>
          <div class="loginboxRight">
            <p class="loginRightTitle">登錄</p>
            <div class="input_plate">
              <p class="inputTitle">用戶名</p>
              <el-input v-model="userName" type="text" clearable placeholder="請輸入賬號"></el-input>
            </div>
            <div class="input_plate">
              <p class="inputTitle">验证码</p>
              <div class="getcode-box flex">
                <el-input class="identCode-input" maxlength="6" v-model="identCode" type="text" clearable placeholder="请输入验证码" @change="identCode=identCode.replace(/\D+/g, '')"></el-input>
              <button @click="getCode()" class="btn">{{getCodeText}}</button>
              </div>

            </div>
            <div class="input_plate">
              <p class="inputTitle">密碼</p>
              <input class="el-input__inner" v-model="passWord" type="password" placeholder="請輸入密碼" @keyup.enter="userLogin">
            </div>
            <button class="login_btn" :style="{background:loginBtnBg}" value="登錄" @click="userLogin">登錄</button>
          </div>

        </div>
      </div>

      <div class="small-content hidden-md-and-up">
          <div class="loginboxRight">
            <p style="margin-bottom:1rem;font-size:0.3rem;color:#292929;font-weight:600;">登錄</p>
            <div class="input_plate">
              <p class="inputTitle">用戶名</p>
              <el-input v-model="userName" type="text" clearable placeholder="請輸入賬號"></el-input>
            </div>

            <div class="input_plate">
              <p class="inputTitle">验证码</p>
              <div class="getcode-box flex">
                <el-input class="identCode-input" v-model="identCode" type="text" clearable placeholder="请输入验证码" @change="identCode=identCode.replace(/\D+/g, '')"></el-input>
              <button @click="getCode()" class="btn">{{getCodeText}}</button>
              </div>

            </div>
            <div class="input_plate">
              <p class="inputTitle">密碼</p>
              <el-input v-model="passWord" type="password" @keyup.enter="userLogin" clearable placeholder="請輸入密碼"></el-input>

              <!-- <input class="el-input__inner" v-model="passWord" type="password" placeholder="請輸入密碼" > -->
            </div>
            <button class="login_btn" :style="{background:loginBtnBg}" value="登錄" @click="userLogin">登錄</button>
          </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import axios from 'axios';
import DiaMess from '@/components/dialog';
import { Toast, Indicator } from 'mint-ui';
export default {
  data () {
    return {
      userName: '',
      identCode: '',
      passWord: '',
      loginBtnBg: 'rgba(108,61,234,1)',
      loginTips: false,
      loginTipsTitle: '',
      getCodeText: '獲取驗證碼',
      seconds: 60,
      clickCode: true,
      dialogVisible: false,
    }
  },
  created () {
    localStorage.removeItem('listname');
    localStorage.removeItem('barIndex');
    localStorage.removeItem('roleType');
    this.$cookie.remove('auth');
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    getCode(){
      let _this = this;
      if (_this.userName === '') {
        _this.$propMessage('請輸入用戶名','error');
        return;
      }
      if (!_this.clickCode) {return false}
      _this.clickCode = false
      _this.getCodeText = "重新獲取(60s)"
      _this.$get(`/request/member/loginVerCode?email=${_this.userName}&type=login`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code==='00000') {
            _this.$propMessage('驗證碼發送成功', 'success');
          } else {
            _this.$propMessage(res.message, 'error');
          }
        })
      let timer = setInterval(() => {
        _this.seconds = _this.seconds - 1
        if (_this.seconds < 10) {
          _this.getCodeText = '重新獲取(0' + _this.seconds + 's)'
        } else {
          _this.getCodeText = '重新獲取(' + _this.seconds + 's)'
        }
        if (_this.seconds < 1) {
          _this.getCodeText = '獲取驗證碼'
          _this.seconds = 60
          _this.clickCode = true
          clearInterval(timer)
        }
      }, 1000)
    },
    userLogin() {
      if (this.userName === '') {
        this.$propMessage('請輸入用戶名','error');

        return;
      }
      if (this.identCode === '') {
        this.$propMessage('請輸入驗證碼','error');

        return;
      }
      if (this.passWord === '') {
        this.$propMessage('請輸入密碼','error');

        return;
      }
      this.loginBtnBg = 'rgba(79,29,215,1)';
      Indicator.open('驗證中');
      let passCode = this.passWord;
      let RsaData = this.$RsaCode(passCode).replace(/\+/g, '%2B');
      axios.post(`/login/form?username=${this.userName}&password=${RsaData}&${this.userName}=${this.identCode}`)
        .then((res) => {
          Indicator.close();
          if (res.status === 200) {
            this.$Mint.Toast({
              message: '登錄成功，請稍候',
              duration: 500
            });
            // 存储用户身份
            let inFifteenMinutes = new Date(new Date().getTime() + 60 * 1000 * 480);
            // 过期时间为8个小时
            // let inFifteenMinutes = 1
            console.log(inFifteenMinutes)
            this.$cookie.set('auth', res.headers.authorization, { expires: inFifteenMinutes });
            localStorage.setItem('role', res.data.username);
            localStorage.setItem('roleType', res.data.role);
            localStorage.setItem('testRole', res.data.test);
            localStorage.setItem('avatarPic', res.data.headUrl);
            localStorage.setItem('nickName', res.data.nickname);
            this.$router.push('/userData');
          }
        })
        .catch((err) => {
          console.log(err)
          if (err.status === 401){
            this.$propMessage(err.data.error, 'error');
          } else  {
            this.$propMessage(err.data.error, 'error');
          }
          Indicator.close();
          return false;
        });
    }
  },
  components: {
    DiaMess,
  }
};
</script>

<style lang="less" scoped>
  .content{
    .loginTop{
      width: 100%;
      height: 0.7rem;
      box-shadow: 0px 3px 16px rgba(0,0,0,0.08);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img{
        display: inline-block;
        width: 0.4rem;
        height: 0.45rem;
        margin: 0 0.43rem 0 0.5rem;
      }
      p{
        font-size: 0.15rem;
        font-family: 'PingFang SC';
        font-weight: bold;
        line-height: 30px;
        color: rgba(41,41,41,1);
      }
    }
    .loginboxRight{
        text-align: left;
        width: 3.2rem;
        margin-top: 0.2rem;
        p.loginRightTitle{
          font-size: .20rem;
          font-weight: bold;
          line-height: 0.38rem;
          color: rgb(40,40,40);
          margin-bottom: 0.2rem;
        }
        .inputTitle{
          color: rgba(41,41,41,1);
          font-size: 14px;
          line-height: 40px;

          @media (max-width: 420px) {
            font-size: 14px;
          }

        }
        .input_plate {
          width: 100%;
          margin: 0 auto;
          margin-bottom: 0.2rem;

          @media (max-width: 420px) {
            width: 90%;
            margin-bottom: 20px;
          }

          .el-input__inner {
            width: 100%;
            font-size: 12px;
            color: #101010;

            @media (max-width: 420px) {
              width: 75%;
              font-size: 14px;
            }

          }
          .identCode-input{
            width: 60%;
          }
          .getcode-box{
            justify-content: space-between;
          }
        }

        .login_btn {
          width: 100%;
          padding: 10px 0;
          border-radius: 4px;
          color: #ffffff;
          font-size: 14px;
          letter-spacing: 2px;
          cursor: pointer;
          margin-top: 35px;

          @media (max-width: 420px) {
            width: 90%;
            margin-top: 20px;
          }

          &:hover {
            opacity: 1;
          }
        }

      }
    .loginWrap{
      width: 100%;
      height: calc(100% - 0.8rem);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.1rem;
      background: url('../../assets/images/login/loginBg.png');
      .loginContent{
        .loginbox{
          display: flex;
          justify-content: space-between;
          margin-top: 0.44rem;
          padding:0.7rem 0.5rem 0.45rem 0.5rem;
          width: 9.6rem;
          height: 5.8rem;
          background-color: #fff;
          border: none;
          box-shadow: 0 12px 36px rgba(227,227,241,1);
          border-radius: 0.12rem;
          .loginboxLeft{
            img{
              width:4.84rem;
              height: 4.56rem;
            }
          }



        }
      }
      .small-content{
        width:80%;
        height: 7rem;
        background: #fff;
        border-radius: 0.12rem;
        box-shadow: 0 12px 36px rgba(227,227,241,1);
        display: flex;
        justify-content: center;
        align-items: center;
        .loginboxRight{
          text-align: center;
          width: 90%;
          margin: 0 auto;
          .input_plate{
            display: flex;
            p{
              width: 1.2rem;
              margin-right: 0.1rem;
            }
          }
        }
      }


    }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue